/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Unit_CharsInputs */



/**
* | output |
* | --- |
* | "chars" |
*
* @param {Signup_Compare_Unit_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_unit_chars = /** @type {((inputs?: Signup_Compare_Unit_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Unit_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("chars")
	if (locale === "de") return /** @type {LocalizedString} */ ("chars")
	if (locale === "it") return /** @type {LocalizedString} */ ("chars")
	if (locale === "ru") return /** @type {LocalizedString} */ ("chars")
	if (locale === "es") return /** @type {LocalizedString} */ ("chars")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("chars")
	if (locale === "ja") return /** @type {LocalizedString} */ ("chars")
	if (locale === "hi") return /** @type {LocalizedString} */ ("chars")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("chars")
	return /** @type {LocalizedString} */ ("chars")
});